import React, {useEffect} from 'react';

import {withRouter, WithRouterProps} from 'react-router';

import {DetailLoadingPage} from 'app/general/loading/DetailLoadingPage';
import {useGuestTaskInstance} from 'app/guest/api';
import {GuestTaskErrorPage} from 'app/guest/components/GuestTaskErrorPage';
import {getPathFromURL} from 'app/utils/urls';

import {useTaskInstance} from '../api';

export const CreateTaskInstancePage = withRouter(
  ({params, router}: WithRouterProps): JSX.Element => {
    const {currentData: task} = useTaskInstance(
      `${params.taskid}-${params.timestamp}`
    );

    useEffect(() => {
      if (task != null) {
        router.replace(
          getPathFromURL(task.html_url) +
            (params.subnav != null ? `${params.subnav}/` : '')
        );
      }
    }, [task]);

    return <DetailLoadingPage />;
  }
);

export const CreateGuestTaskInstancePage = withRouter(
  ({params, router}: WithRouterProps): JSX.Element => {
    const {
      data: task,
      isError,
      error,
    } = useGuestTaskInstance(`${params.taskid}-${params.timestamp}`);

    if (isError) {
      return <GuestTaskErrorPage error={error} />;
    }

    useEffect(() => {
      if (task != null) {
        router.replace(getPathFromURL(task.html_url));
      }
    }, [task]);

    return <DetailLoadingPage />;
  }
);
